import React, { ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import { MCreateTeam } from '../../lib';

function RouteMobCreateTeam(props: RouteComponentProps & ComponentProps<any>) {
    const parentPath: string = fomatParentPath(props);
    return (
        <Route weId={`${props.weId || ''}_x7eiky`} path={`${parentPath}/mobile/uk/createTeam`}>
            {
                <MCreateTeam weId={`${props.weId || ''}_jx0jn0`} />
            }
        </Route>
    )
}

export default withRouter(RouteMobCreateTeam);